import bootLayout from 'static/script/app/boot/boot-layout';
import BinFormUI from 'static/script/app/ui/bin-form-ui';

export default initData => {
    bootLayout(initData);
    BinFormUI.attachTo('[data-bin-form]');
};


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/pages/bin-form.js